import DashboardOutlinedIcon from "@mui/icons-material/DashboardOutlined";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import LocalFireDepartmentOutlinedIcon from "@mui/icons-material/LocalFireDepartmentOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import PeopleOutlinedIcon from "@mui/icons-material/PeopleOutlined";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import AssignmentOutlinedIcon from "@mui/icons-material/AssignmentOutlined";
import LightbulbOutlinedIcon from "@mui/icons-material/LightbulbOutlined";
import FolderOpenOutlinedIcon from "@mui/icons-material/FolderOpenOutlined";
import FolderCopyOutlinedIcon from "@mui/icons-material/FolderCopyOutlined";
import FlightTakeoffOutlinedIcon from "@mui/icons-material/FlightTakeoffOutlined";
import FlightOutlinedIcon from "@mui/icons-material/FlightOutlined";
import EventOutlinedIcon from "@mui/icons-material/EventOutlined";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import ReceiptLongOutlinedIcon from "@mui/icons-material/ReceiptLongOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import BalanceOutlinedIcon from "@mui/icons-material/BalanceOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import CurrencyExchangeOutlinedIcon from "@mui/icons-material/CurrencyExchangeOutlined";
import AdminPanelSettingsOutlinedIcon from "@mui/icons-material/AdminPanelSettingsOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import CompareArrowsOutlinedIcon from "@mui/icons-material/CompareArrowsOutlined";
import PriceChangeOutlinedIcon from "@mui/icons-material/PriceChangeOutlined";
import MemoryOutlinedIcon from "@mui/icons-material/MemoryOutlined";
import StorefrontOutlinedIcon from "@mui/icons-material/StorefrontOutlined";
import TravelExploreOutlinedIcon from "@mui/icons-material/TravelExploreOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import WarehouseOutlinedIcon from "@mui/icons-material/WarehouseOutlined";
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import LocalOfferOutlinedIcon from "@mui/icons-material/LocalOfferOutlined";
import RequestQuoteOutlinedIcon from "@mui/icons-material/RequestQuoteOutlined";

export const routeActive = (pathname, path, matchPaths = []) => {
  if (!path && (!matchPaths || !matchPaths.length)) return false;
  const paths = [path, ...(matchPaths || [])].filter(Boolean);
  return paths.some((p) => {
    if (pathname === p) return true;
    if (p !== "/" && pathname.startsWith(`${p}/`)) return true;
    return false;
  });
};

/**
 * Üst navbar kısayolları — günlük işte en çok kullanılan sekmeler.
 * Kısa `label` header’da gösterilir; `title` tooltip.
 */
export const headerNavItems = [
  { text: "Dashboard", label: "Dashboard", title: "Command Center", path: "/dashboard", Icon: DashboardOutlinedIcon },
  { text: "LiveOps", label: "Live Ops", title: "Live Ops", path: "/live-ops", Icon: FlightTakeoffOutlinedIcon },
  { text: "IliskiPipeline", label: "İlişkiler", title: "Müşteri ilişkileri", path: "/iliski-pipeline", Icon: GroupsOutlinedIcon },
  {
    text: "Orders",
    label: "Siparişler",
    title: "Siparişler",
    path: "/orders",
    matchPaths: ["/manual-order"],
    Icon: LocalShippingOutlinedIcon,
  },
  { text: "Gorevler", label: "Görevler", title: "Görev merkezi", path: "/gorevler", Icon: AssignmentOutlinedIcon },
  {
    text: "AbandonedCarts",
    label: "Sepetler",
    title: "Terk edilen sepetler",
    path: "/terk-edilen-sepetler",
    Icon: ShoppingCartOutlinedIcon,
  },
  { text: "Analyze", label: "Kar-Zarar", title: "Kar-zarar hesabı", path: "/finans/kar-zarar", Icon: BalanceOutlinedIcon },
];

/**
 * Sidebar menüsü — kategori kategori gruplanmış.
 * Sıra: günlük iş → satış → ürün → stok → ilişkiler → fiyat → finans → iletişim → hesap.
 */
export const navItems = [
  {
    category: "Özet",
    items: [
      { text: "Dashboard", title: "Command Center", path: "/dashboard", Icon: DashboardOutlinedIcon },
      {
        text: "LiveOps",
        title: "Live Ops",
        path: "/live-ops",
        Icon: FlightTakeoffOutlinedIcon,
      },
      { text: "Performance", title: "Performans", path: "/performance", Icon: TrendingUpOutlinedIcon },
    ],
  },
  {
    category: "İş & Projeler",
    items: [
      { text: "Gorevler", title: "Görev merkezi", path: "/gorevler", Icon: AssignmentOutlinedIcon },
      { text: "Projeler", title: "Projeler", path: "/projeler", Icon: FolderOpenOutlinedIcon },
      { text: "IliskiPipeline", title: "Müşteri ilişkileri", path: "/iliski-pipeline", Icon: GroupsOutlinedIcon },
      { text: "ProjeArsivi", title: "Proje arşivi", path: "/proje-arsivi", Icon: FolderCopyOutlinedIcon },
    ],
  },
  {
    category: "Satış",
    items: [
      { text: "Orders", title: "Siparişler", path: "/orders", matchPaths: ["/manual-order"], Icon: LocalShippingOutlinedIcon },
      {
        text: "AbandonedCarts",
        title: "Terk edilen sepetler",
        path: "/terk-edilen-sepetler",
        Icon: ShoppingCartOutlinedIcon,
      },
      { text: "Quotes", title: "Teklifler", path: "/teklifler", Icon: RequestQuoteOutlinedIcon },
      { text: "Proforms", title: "Proformalar", path: "/proformalar", Icon: DescriptionOutlinedIcon },
      { text: "Transactions", title: "Faturalar", path: "/transactions", Icon: ReceiptLongOutlinedIcon },
    ],
  },
  {
    category: "Ürünler & İçerik",
    items: [
      { text: "Products", title: "Ürünler", path: "/products", Icon: Inventory2OutlinedIcon },
      {
        text: "PopularProducts",
        title: "Popüler ürünler",
        path: "/populer-urunler",
        Icon: LocalFireDepartmentOutlinedIcon,
      },
      { text: "TechnicalBlog", title: "Teknik blog", path: "/teknik-blog", Icon: ArticleOutlinedIcon },
      { text: "UrunFikirleri", title: "Ürün fikirleri", path: "/urun-fikirleri", Icon: LightbulbOutlinedIcon },
      { text: "SeoReadiness", title: "SEO & AI hazırlık", path: "/seo-readiness", Icon: TravelExploreOutlinedIcon },
      {
        text: "DatasheetGenerator",
        title: "Datasheet oluşturucu",
        path: "/datasheet-generator",
        Icon: PictureAsPdfOutlinedIcon,
      },
      {
        text: "ProductSkuCatalog",
        title: "SKU & Datasheet kataloğu",
        path: "/urun-sku-datasheet",
        Icon: LocalOfferOutlinedIcon,
      },
    ],
  },
  {
    category: "Stok & Pazaryeri",
    items: [
      { text: "OfisStok", title: "Ofis stok", path: "/ofis-stok", Icon: WarehouseOutlinedIcon },
      {
        text: "OfisStogaCekilecek",
        title: "Stok adayları",
        path: "/ofis-stoga-cekilecek",
        Icon: Inventory2OutlinedIcon,
      },
      { text: "HbRpi", title: "HB RPI hazırlık", path: "/hb-rpi", Icon: MemoryOutlinedIcon },
    ],
  },
  {
    category: "Müşteri & Tedarik",
    items: [
      { text: "Customers", title: "Müşteriler", path: "/customers", Icon: PeopleOutlinedIcon },
      { text: "Tedarikci", title: "Tedarikçiler", path: "/tedarikci", Icon: HandshakeOutlinedIcon },
      { text: "SatinAlma", title: "Satın alma formu", path: "/satin-alma-formu", Icon: FactCheckOutlinedIcon },
      { text: "CinSeyahati", title: "Tedarikçi Notları", path: "/cin-seyahati", Icon: FlightOutlinedIcon },
      { text: "CinToplantilar", title: "Toplantılar", path: "/cin-toplantilar", Icon: EventOutlinedIcon },
    ],
  },
  {
    category: "Fiyat & Rekabet",
    items: [
      {
        text: "PriceLists",
        title: "Fiyat listesi",
        path: "/fiyat-listesi",
        Icon: PriceChangeOutlinedIcon,
      },
      {
        text: "FiyatGuncelleme",
        title: "TR + Global güncelleme",
        path: "/fiyat-guncelleme",
        Icon: CurrencyExchangeOutlinedIcon,
      },
      {
        text: "RekabetOlcemu",
        title: "ABD fiyat karşılaştırma",
        path: "/abd-fiyat-karsilastirma",
        Icon: CompareArrowsOutlinedIcon,
      },
      {
        text: "Hepsiburada",
        title: "Hepsiburada fiyat",
        path: "/hepsiburada-fiyat",
        Icon: StorefrontOutlinedIcon,
      },
    ],
  },
  {
    category: "Finans",
    items: [
      { text: "Analyze", title: "Kar-zarar hesabı", path: "/finans/kar-zarar", Icon: BalanceOutlinedIcon },
      {
        text: "HepsiburadaOrders",
        title: "Hepsiburada siparişler",
        path: "/finans/hepsiburada",
        Icon: StorefrontOutlinedIcon,
      },
      { text: "Prim", title: "Prim hesaplama", path: "/finans/prim", Icon: PaymentsOutlinedIcon },
      {
        text: "CurrencyConverter",
        title: "Kur dönüştürücü",
        path: "/finans/kur",
        Icon: CurrencyExchangeOutlinedIcon,
      },
      {
        text: "LandedCost",
        title: "Geriye Dönük Sipariş Maliyeti",
        path: "/landed-cost",
        Icon: TravelExploreOutlinedIcon,
      },
    ],
  },
  {
    category: "Hesap & Sistem",
    items: [
      { text: "Profile", title: "Profil ayarları", path: "/profil", Icon: SettingsOutlinedIcon },
      { text: "Admin", title: "Yönetici listesi", path: "/admin", Icon: AdminPanelSettingsOutlinedIcon },
    ],
  },
];
